/** 协同委外库存流水 — 单据类型 / 变动类型 / 入参 */

export const FLOW_CHANGE_TYPE = {
  OUT: 0,
  IN: 1,
}

export const FLOW_CHANGE_TYPE_OPTIONS = [
  { label: '出库', value: FLOW_CHANGE_TYPE.OUT },
  { label: '入库', value: FLOW_CHANGE_TYPE.IN },
]

export const FLOW_DOC_TYPE = {
  COOP_RECEIVE: 'COOP_RECEIVE',
  COOP_RECEIVE_CANCEL: 'COOP_RECEIVE_CANCEL',
  COOP_DELIVERY_AUDIT: 'COOP_DELIVERY_AUDIT',
  COOP_DELIVERY_UNAUDIT: 'COOP_DELIVERY_UNAUDIT',
  COOP_DELIVERY_OUT: 'COOP_DELIVERY_OUT',
  COOP_DELIVERY_OUT_CANCEL: 'COOP_DELIVERY_OUT_CANCEL',
  COOP_DELIVERY_BOM_OUT: 'COOP_DELIVERY_BOM_OUT',
  COOP_DELIVERY_BOM_OUT_CANCEL: 'COOP_DELIVERY_BOM_OUT_CANCEL',
  COOP_PROCESS_RECEIVE: 'COOP_PROCESS_RECEIVE',
  COOP_PROCESS_RECEIVE_CANCEL: 'COOP_PROCESS_RECEIVE_CANCEL',
  COOP_PROCESS_DELIVERY_AUDIT: 'COOP_PROCESS_DELIVERY_AUDIT',
  COOP_PROCESS_DELIVERY_UNAUDIT: 'COOP_PROCESS_DELIVERY_UNAUDIT',
  COOP_PROCESS_DELIVERY_OUT: 'COOP_PROCESS_DELIVERY_OUT',
  COOP_PROCESS_DELIVERY_OUT_CANCEL: 'COOP_PROCESS_DELIVERY_OUT_CANCEL',
  COOP_PROCESS_DETAIL_OUT: 'COOP_PROCESS_DETAIL_OUT',
  COOP_PROCESS_DETAIL_OUT_CANCEL: 'COOP_PROCESS_DETAIL_OUT_CANCEL',
}

export const FLOW_DOC_TYPE_OPTIONS = [
  { label: '产品收料入库', value: FLOW_DOC_TYPE.COOP_RECEIVE },
  { label: '产品收料撤销', value: FLOW_DOC_TYPE.COOP_RECEIVE_CANCEL },
  { label: '产品出货审核', value: FLOW_DOC_TYPE.COOP_DELIVERY_AUDIT },
  { label: '产品出货反审', value: FLOW_DOC_TYPE.COOP_DELIVERY_UNAUDIT },
  { label: '产品出货出库', value: FLOW_DOC_TYPE.COOP_DELIVERY_OUT },
  { label: '产品出货出库撤销', value: FLOW_DOC_TYPE.COOP_DELIVERY_OUT_CANCEL },
  { label: '出货BOM扣料', value: FLOW_DOC_TYPE.COOP_DELIVERY_BOM_OUT },
  { label: '出货BOM扣料撤销', value: FLOW_DOC_TYPE.COOP_DELIVERY_BOM_OUT_CANCEL },
  { label: '工序收料入库', value: FLOW_DOC_TYPE.COOP_PROCESS_RECEIVE },
  { label: '工序收料撤销', value: FLOW_DOC_TYPE.COOP_PROCESS_RECEIVE_CANCEL },
  { label: '工序发货审核', value: FLOW_DOC_TYPE.COOP_PROCESS_DELIVERY_AUDIT },
  { label: '工序发货反审', value: FLOW_DOC_TYPE.COOP_PROCESS_DELIVERY_UNAUDIT },
  { label: '工序发货出库', value: FLOW_DOC_TYPE.COOP_PROCESS_DELIVERY_OUT },
  { label: '工序发货出库撤销', value: FLOW_DOC_TYPE.COOP_PROCESS_DELIVERY_OUT_CANCEL },
  { label: '工序明细出库', value: FLOW_DOC_TYPE.COOP_PROCESS_DETAIL_OUT },
  { label: '工序明细出库撤销', value: FLOW_DOC_TYPE.COOP_PROCESS_DETAIL_OUT_CANCEL },
]

const DOC_TYPE_LABEL_MAP = FLOW_DOC_TYPE_OPTIONS.reduce((map, item) => {
  map[item.value] = item.label
  return map
}, {})

export function getFlowDocTypeLabel(docType) {
  if (docType == null || docType === '') return '--'
  return DOC_TYPE_LABEL_MAP[docType] || docType
}

export function getFlowChangeTypeLabel(changeType) {
  const type = Number(changeType)
  if (type === FLOW_CHANGE_TYPE.IN) return '入库'
  if (type === FLOW_CHANGE_TYPE.OUT) return '出库'
  return '--'
}

/** 0 物料 / 1 半成品成品 */
export function getFlowMaterialKindLabel(productionOrMaterial) {
  const kind = Number(productionOrMaterial)
  if (kind === 1) return '半成品/成品'
  if (kind === 0) return '物料'
  return '--'
}

export function normalizeWarehouseFlowRow(row = {}) {
  return {
    ...row,
    id: row.outsourcingWarehouseFlowId,
    _docTypeLabel: getFlowDocTypeLabel(row.docType),
    _changeTypeLabel: getFlowChangeTypeLabel(row.changeType),
    _materialKindLabel: getFlowMaterialKindLabel(row.productionOrMaterial),
  }
}

/** 构建 /outsourcingWarehouse/flowList 入参 */
export function buildWarehouseFlowListPayload({
  outsourcingWarehouseId,
  searchData = {},
  pageParam = { pageNum: 1, pageSize: 20 },
  orderParam = [{ asc: false, fieldName: 'createTime' }],
} = {}) {
  const flowFilter = {
    searchString: (searchData.searchString || '').trim() || null,
  }

  const warehouseId =
    outsourcingWarehouseId || searchData.outsourcingWarehouseId
  if (warehouseId !== null && warehouseId !== undefined && warehouseId !== '') {
    flowFilter.outsourcingWarehouseId = warehouseId
  }

  if (searchData.docType) {
    flowFilter.docType = searchData.docType
  }

  if (
    searchData.productionOrMaterial !== '' &&
    searchData.productionOrMaterial !== null &&
    searchData.productionOrMaterial !== undefined
  ) {
    flowFilter.productionOrMaterial = Number(searchData.productionOrMaterial)
  }

  if (searchData.baseOutsourcingDocId) {
    flowFilter.baseOutsourcingDocId = searchData.baseOutsourcingDocId
  }

  if (searchData.docId) {
    flowFilter.docId = searchData.docId
  }

  return {
    flowFilter,
    pageParam: {
      pageNum: pageParam.pageNum || 1,
      pageSize: pageParam.pageSize || 20,
    },
    orderParam: Array.isArray(orderParam) ? orderParam : [],
  }
}
